import CaseStudiesColor from './CaseStudiesColour.svg';
import CaseStudiesDark from './CaseStudiesDark.svg';
import CaseStudiesLight from './CaseStudiesLight.svg';
export const caseStudies = { color: CaseStudiesColor, dark: CaseStudiesDark, light: CaseStudiesLight };
//# sourceMappingURL=index.js.map